import { FC } from 'react';
import QRCode from 'react-qr-code';
import classNames from 'classnames';
import { ENV_VARIABLE } from 'utils/constants';
import styles from './index.module.scss';

interface HostCardQrCodeProps {
	className?: string;
	size?: number;
}

export const HostCardQrCode: FC<HostCardQrCodeProps> = ({ className = '', size = 256 }) => {
	return (
		!!ENV_VARIABLE.CARD_BANNER_QR_CODE_URL && (
			<div className={classNames(styles.qr, className)}>
				<QRCode size={size} value={ENV_VARIABLE.CARD_BANNER_QR_CODE_URL} width="100%" height="100%" />
			</div>
		)
	);
};
